module.exports = __webpack_public_path__ + "img/panoramic-about.9963e59d.jpg";